import React from "react";
import { Formik } from "formik";
import { Button, Form, Card } from "react-bootstrap";
import Select from "react-select";
import * as Yup from "yup";
import useLeadsStore from "../../../../store/LeadsStore";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toaster from '../../../../utils/toaster'
import SpinnerButton from "../../../SpinnerButton/SpinnerButton";
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { useApiClient } from '../../../../hooks/useApiClient';
import useModalStore from "../../../../store/ModalStore";
import SelectOptWithSubtitle from '../../../SelectOptWithSubtitle/SelectOptWithSubtitle';
import { useErrorToast } from "../../../../hooks/useErrorToast";


const LeadReAssign = () => {
  const { userSalesOptions, checkedLeads, setCheckedLeads } = useLeadsStore();
  const { closeModal } = useModalStore();
  const { t } = useTranslation()
  const { apiClient } = useApiClient();
  const queryClient = useQueryClient();
  const { showError } = useErrorToast();

  const initialValues = {
    assignSale: null,
  };

  const validationSchema = Yup.object().shape({
    assignSale: Yup.object().required(i18next.t('assign_sales_user_required')),
  });


  const reassignLeadMutation = useMutation({
    mutationFn: (salesUser: string) => {
      if (!checkedLeads.length) {
        toaster.error(i18next.t('lead_id_required'));
        throw new Error(i18next.t('lead_id_required'));
      }

      const reassignLeadpayload = {
        ids: checkedLeads,
        newOwnerEmail: salesUser
      }
      return apiClient.leadsControllerService.reassignLead(reassignLeadpayload);
    },
    onSuccess: (data) => {
      toaster.success(i18next.t('lead_reassigned_successfully'));
      queryClient.invalidateQueries({ queryKey: ["leads_list"] });
      setCheckedLeads([])
      closeModal()
    },

    onError: (error) => {
      console.error(i18next.t('error_reassign_lead'), error);
      showError(error, i18next.t('error_reassign_lead'));
    },
  });


  const handleSubmit = (values) => {
    reassignLeadMutation.mutate(values.assignSale.value);
  }

  return (
    <Card className="p-3">
      {/* <Card.Header> */}
      <div className="h6">{t('number_selected_leads')}: {checkedLeads.length}</div>
      {/* </Card.Header> */}
      <Card.Body style={{ padding: "20px 0px" }}>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSubmit(values)
          }}
        >
          {({ values, errors, touched, handleSubmit, setFieldValue }) => (
            <Form onSubmit={handleSubmit} className="">
              <Form.Group className="mb-3" >
                <Form.Label>{t('reassign_lead')}</Form.Label>
                <Select
                  menuPosition="fixed"
                  options={userSalesOptions}
                  name="assignSale"
                  onChange={(option) => setFieldValue("assignSale", option)}
                  value={values.assignSale}
                  components={{
                    Option: (props: any) => {
                      return (
                        <SelectOptWithSubtitle
                          {...props}
                        ></SelectOptWithSubtitle>
                      );
                    },
                  }}
                />
                {errors.assignSale && touched.assignSale && (
                  <div className="text-danger">{errors.assignSale}</div>
                )}
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                disabled={reassignLeadMutation.isPending}
              >
                <SpinnerButton
                  busy={reassignLeadMutation.isPending}
                  label={i18next.t("save")}
                />
              </Button>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>

  );
};

export default LeadReAssign;
